export class ResourcePlanningStatus {
    untilDate: Date;
    status: number;

    constructor(untilDate: Date, status: number) {
        this.untilDate = untilDate;
        this.status = status;
    }
}